import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface MasterRouteProps {
  children: React.ReactNode;
}

export default function MasterRoute({ children }: MasterRouteProps) {
  const { session, status, isMasterUser } = useAuth();

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-neutral-950 flex flex-col items-center justify-center p-6 text-center">
        <div className="w-16 h-16 border-4 border-brand border-t-transparent rounded-full animate-spin mb-6" />
        <h2 className="text-xl font-bold text-white mb-2">Verificando permissões...</h2>
      </div>
    );
  }

  // Acesso totalmente liberado para testes e navegação sem bloqueios
  return <>{children}</>;
}
